import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Flex, Input, Text } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, RoundedButton } from '@codametrix/ui-components';
import { ModalComponent } from '../../../components/Modal/modal';
import { Button } from '../../../components/button/button';
import { toggleEmailConfirmationModal, confirmEmail, getConfig } from '../../../actions/login.action';
import { styles } from './confirm-email-modal.styles';
import './confirm-email-modal.scss';
import { isNewDesign } from '../../../core/middleware/new-design-middleware';
export const ConfirmEmailModal = ()=>{
    const classes = styles();
    const dispatch = useDispatch();
    const [isNewDesign2, setIsNewDesign2] = useState(isNewDesign);
    const { username, auth } = useSelector((state)=>state.login);
    const { context } = useSelector((state)=>state.ui);
    const [confirmationCode, editConfirmationCode] = useState('');
    const _handleClose = ()=>{
        dispatch(toggleEmailConfirmationModal(false));
    };
    const _handleSubmit = ()=>{
        const loginData = {
            username: username ?? '',
            confirmationCode,
            token: auth,
            context
        };
        dispatch(confirmEmail(loginData));
    };
    useEffect(()=>{
        const fetchConfig = async ()=>{
            const { newDesign } = await getConfig();
            setIsNewDesign2(newDesign?.enabled);
        };
        fetchConfig();
    }, [
        isNewDesign2
    ]);
    return isNewDesign ? /*#__PURE__*/ _jsx(ModalComponent, {
        "data-test-id": "confirm-email-modal",
        size: 'xl',
        isOpen: true,
        handleClose: _handleClose,
        showCloseIcon: true,
        modalHeader: /*#__PURE__*/ _jsx("p", {
            children: "Account Migration Required"
        }),
        modalContent: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: 'column',
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    sx: classes.label,
                    children: "Existing accounts need to be migrated to our new authentication platform."
                }),
                /*#__PURE__*/ _jsx(Text, {
                    sx: classes.label,
                    children: "You should receive an email with a confirmation code, please enter it here. This should be a one-time process."
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "form-group",
                    children: /*#__PURE__*/ _jsx(Input, {
                        sx: classes.input,
                        className: "form-input confirmation-code-field",
                        maxLength: 6,
                        type: "text",
                        name: "confirmation-code",
                        onChange: (e)=>editConfirmationCode(e.target.value)
                    })
                })
            ]
        }),
        modalFooter: /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(Button, {
                dataTestId: "saveBtn",
                label: "Confirm",
                onClick: _handleSubmit
            })
        })
    }) : /*#__PURE__*/ _jsx(Modal, {
        onClose: _handleClose,
        title: "Account Migration Required",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "confirm-email-modal",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    children: "Existing accounts need to be migrated to our new authentication platform."
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: "You should receive an email with a confirmation code, please enter it here."
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "input",
                            children: /*#__PURE__*/ _jsx("input", {
                                className: "form-input confirmation-code-field",
                                "data-test-id": "confirm-email-modal",
                                maxLength: 6,
                                type: "text",
                                name: "confirmation-code",
                                onChange: (e)=>editConfirmationCode(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "buttons",
                            children: /*#__PURE__*/ _jsx(RoundedButton, {
                                className: "btn-sm active confirm-btn",
                                type: "submit",
                                title: "Confirm",
                                onClick: _handleSubmit,
                                children: "Confirm"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
